import { mergeStyles } from "@uifabric/styling";
import { memoizeFunction } from "@uifabric/utilities";
var getClassNames = memoizeFunction(function (styles, className) {
    return {
        root: mergeStyles("stack", className, styles.root),
        header: mergeStyles("stack-header", styles.header),
        tabBar: mergeStyles("stack-tab-bar", styles.tabBar),
        actionBar: mergeStyles("stack-action-bar", styles.actionBar),
        action: mergeStyles("stack-action", styles.action),
        actionIcon: mergeStyles("stack-action-icon", styles.actionIcon),
        addAction: mergeStyles("stack-add-action", styles.addAction),
        tab: mergeStyles("stack-tab", styles.tab),
        tabTitleContainer: mergeStyles("stack-tab-title-container", styles.tabTitleContainer),
        tabTitle: mergeStyles("stack-tab-title", styles.tabTitle),
        tabActionBar: mergeStyles("stack-tab-action-bar", styles.tabActionBar),
        tabAction: mergeStyles("stack-tab-action", styles.tabAction),
        tabActionIcon: mergeStyles("stack-tab-action-icon", styles.tabActionIcon),
        tabPanel: mergeStyles("stack-tab-panel", styles.tabPanel),
        body: mergeStyles("stack-body", styles.body),
        dragOverlay: mergeStyles("stack-drag-overlay", styles.dragOverlay),
        dragOverlayFeedback: mergeStyles("stack-drag-overlay-feedback", styles.dragOverlayFeedback)
    };
});
export { getClassNames };
